import qs from 'query-string';

export const getQueryParam = (name: string) => {
  return qs.parse(window.location.search)[name];
};
